import React, { ReactElement } from 'react';

const NoResults = (): ReactElement => {
    return (
        <div className="section filter-no-results">
            <h2 className="h2 filter-no-results__title">
                {"Sorry, we couldn't find any results matching your search. Please try again."}
            </h2>
        </div>
    );
};

export { NoResults };
